module.exports = __webpack_public_path__ + "static/media/velma.478fc97e.png";